var map = {
	"./anm-card.png": 1219,
	"./arrow.png": 1220,
	"./arrow.webp": 1221,
	"./asset-1.svg": 1222,
	"./bg-exclusive.webp": 1223,
	"./boost.svg": 1224,
	"./brand-logo-cny.png": 1225,
	"./brand-logo-raya.webp": 1226,
	"./brand-logo.png": 111,
	"./brand-logo.webp": 1227,
	"./btn-black-m.webp": 1228,
	"./btn-blue-m-v2.png": 1229,
	"./btn-blue-m.png": 1230,
	"./btn-blue-m.webp": 1231,
	"./btn-white-m-v2.png": 1232,
	"./btn-white-m.png": 1233,
	"./check-btn.webp": 1234,
	"./default-bg.webp": 1235,
	"./deposit.webp": 1236,
	"./drop-more-btn.webp": 1237,
	"./duitnow.svg": 1238,
	"./eeziepay.svg": 1239,
	"./fcl.svg": 1240,
	"./fcl.webp": 1241,
	"./fpx-logo.svg": 1242,
	"./game-blue.png": 1243,
	"./game-img.png": 1244,
	"./game-white.png": 1245,
	"./global-language.svg": 1246,
	"./grabpay.svg": 1247,
	"./ifm-logo.svg": 1248,
	"./ifm-logo.webp": 1249,
	"./modal-bg.jpg": 1250,
	"./number-bg.webp": 1251,
	"./pagcor.svg": 1252,
	"./pagcor.webp": 1253,
	"./pool-bg.webp": 1254,
	"./promo-given.webp": 1255,
	"./side-bar-bg.png": 1256,
	"./spotlight-base.svg": 1257,
	"./spotlight.svg": 1258,
	"./tether.svg": 1259,
	"./title-asset.svg": 1260,
	"./tng.svg": 1261,
	"./winner.webp": 1262,
	"./withdrawal.webp": 1263
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 171;